import React from 'react';
import { useGame } from '../contexts/GameContext';
import ErrorMessage from './ErrorMessage';
import { useLocation, useNavigate } from 'react-router-dom';
import './ConnectionStatus.css';

const ConnectionStatus = () => {
  const { state, actions } = useGame();
  const location = useLocation();
  const navigate = useNavigate();
  const assetBasePath = `${process.env.PUBLIC_URL || ''}/resource/lobby`;
  const connectionStatusStyles = {
    '--home-btn-default': `url(${assetBasePath}/btn-home.png)`,
    '--home-btn-hover': `url(${assetBasePath}/btn-home-os.png)`
  };

  // 페이지 경로에 따른 제목 매핑
  const getPageTitle = () => {
    switch (location.pathname) {
      case '/lobby':
        return '게임 로비';
      case '/room':
        return '방';
      case '/game':
        return '게임';
      default:
        return '';
    }
  };

  const pageTitle = getPageTitle();

  // 홈으로 이동
  const goToHome = () => {
    navigate('/');
  };

  // 연결 상태에 따른 아이콘과 메시지
  const getConnectionInfo = () => {
    if (state.ui.isConnected) {
      return {
        icon: '🟢',
        message: '서버에 연결됨',
        className: 'connected'
      };
    } else {
      return {
        icon: '🔴',
        message: '서버 연결 중...',
        className: 'disconnected'
      };
    }
  };

  const connectionInfo = getConnectionInfo();

  return (
    <div
      className={`connection-status-bar ${connectionInfo.className}`}
      style={connectionStatusStyles}
    >
      <button
        type="button"
        className="home-button"
        onClick={goToHome}
        aria-label="홈으로"
      />
      
      {pageTitle && (
        <div className="page-title">
          {pageTitle}
        </div>
      )}
      
      <div className="connection-info">
        <span className="connection-icon">{connectionInfo.icon}</span>
        <span className="connection-message">{connectionInfo.message}</span>
      </div>
      
      {state.ui.error && (
        <ErrorMessage
          message={state.ui.error}
          onClose={actions.clearError}
          isGlobal={true}
        />
      )}
    </div>
  );
};

export default ConnectionStatus;
